/* eslint-disable @typescript-eslint/naming-convention */
import { injectable } from '@servicetitan/react-ioc';

import { getWidgetInstanceId } from '../utils/get-widget-instance-id';

interface IAnalytics {
    track(eventName: string, params: Record<string, unknown>): void;
    page(name: string): void;
}

@injectable()
export class AnalyticsStore {
    stepOpenedTimestamp: number | undefined;
    widgetInstanceId: string | undefined;

    get analytics(): IAnalytics {
        return (window as any).analytics;
    }

    init = () => {
        this.widgetInstanceId = getWidgetInstanceId();
    };

    widgetLoadedOutsideOfIframe = () => {
        this.analytics.track('widget loaded outside of iframe', {
            tenant_token: this.widgetInstanceId,
            date: new Date(),
        });
    };

    widgetLoadedInWrongWebsite = (website: string) => {
        this.analytics.track('widget loaded in wrong website', {
            tenant_token: this.widgetInstanceId,
            date: new Date(),
            website,
        });
    };

    widgetOpened = () => {
        this.analytics.track('widget opened', {
            tenant_token: this.widgetInstanceId,
            date: new Date(),
        });
    };

    widgetClosed = () => {
        this.analytics.track('widget closed', {
            tenant_token: this.widgetInstanceId,
            date: new Date(),
        });
    };

    messageSent = () => {
        this.analytics.track('widget message sent', {
            tenant_token: this.widgetInstanceId,
            date: new Date(),
        });
    };

    sendingMessage = (data: any) => {
        this.analytics.track('widget sending message', {
            tenant_token: this.widgetInstanceId,
            date: new Date(),
            data,
        });
    };

    trackValidationError = (fieldName: string, message: string) => {
        this.analytics.track('widget validation error', {
            tenant_token: this.widgetInstanceId,
            field_name: fieldName,
            message,
        });
    };
}
